export const ITEMS_COUNT_SKEW = [0, 0, 0, 0, 18,  12,  8,  7,  5,  4,  3,  3,  2,  2]
export const TRUCK_SELECT = 'TRUCK_SELECT'
export const SIMULATION_SELECT = 'SIMULATION_SELECT'

export const LG = 1199.8
export const MD = 991.8
export const SM = 812.8

const SWITCHER_SIZES = [
  {
    between: [Infinity, LG],
    width: 100,
    height: 20,
    togglerWidth: 32,
  },
  {
    between: [LG, MD],
    width: 90,
    height: 20,
    togglerWidth: 32,
  },
  {
    between: [MD, SM],
    width: 86,
    height: 20,
    togglerWidth: 32,
  },
  {
    between: [SM, -Infinity],
    width: 55,
    height: 11,
    togglerWidth: 20,
  },
]

export const getSwitcherSize = () => 
  SWITCHER_SIZES.find(({between}) => 
    window.innerWidth < between[0] && window.innerWidth > between[1]
  )!

export const REMOTE_TOGGLER = 'toggler'

export const FINGER_ANIMATION = 'Finger'